import { useAppDialogsStore } from './appDialogsStore'
import { ContentDialog } from './dialogs/ContentDialog'

function AppDialogs() {
  const { showContentDialog, setShowContentDialog } = useAppDialogsStore()
  return (
    <div>
      {showContentDialog && (
        <ContentDialog
          contentId={showContentDialog}
          onClose={() => setShowContentDialog(null)}
        />
      )}
    </div>
  )
}

export { AppDialogs }
